// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"39dcf5ad","338":"35a3c565","476":"f65c3269","488":"34db1d93","691":"093646b8","837":"a889744b"}[chunkId] + ".chunk.js";
};